export default __webpack_public_path__ + "static/media/service-zerspanung.635a5a5f.webp";